// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.
require.context("../images", true)
require("trix")
require("@rails/actiontext")

import "css/active_admin";

import "javascripts/active_material";
import "@activeadmin/activeadmin";

import "activeadmin_addons";

import moment from 'moment'

window.moment = moment
import $ from "jquery";

window.jQuery = $;
window.$ = $;

import flatpickr from "flatpickr";

const Italian = require("flatpickr/dist/l10n/it.js").default.it;
import JSONEditor from "jsoneditor";

var recompute_positions = function (parent) {
    parent = parent instanceof jQuery ? parent : $(this);
    const input_name = parent.data('sortable');
    let position = parseInt(parent.data('sortable-start') || 0, 10);

    parent.children('fieldset').each(function () {
        // We ignore nested inputs, so when defining your has_many, be sure to keep
        // your sortable input at the root of the has_many block.
        const destroy_input = $(this).find("> ol > .input > :input[name$='[_destroy]']");
        const sortable_input = $(this).find(`> ol > .input > :input[name$='[${input_name}]']`);

        if (sortable_input.length) {
            sortable_input.val(destroy_input.is(':checked') ? '' : position++);
        }
    });
};

function initFlatpickr($container) {
    let selector = ".flatpickr"

    let $elements = $container.find(selector)

    if ($elements.length > 0) {
        $elements.each(function (index, element) {
            flatpickr(element, {
                enableTime: true,
                dateFormat: 'Z',
                altFormat: "d/m/Y H:i",
                altInput: true,
                allowInput: true,
                time_24hr: true,
                locale: Italian,
                onReady: function(dateObj, dateStr, instance) {
                    var $cal = $(instance.calendarContainer);
                    if ($cal.find('.flatpickr-clear').length < 1) {
                        $cal.append('<div class="flatpickr-clear" style="font-weight: bold;\n' +
                            '    border-top: 1px solid #e6e6e6;\n' +
                            '    padding: 8px;">Clear</div>');
                        $cal.find('.flatpickr-clear').on('click', function() {
                            instance.clear();
                            instance.close();
                        });
                    }
                }

            })
        })

    }
}

let characters = [];

function loadChars($selectOpera) {
    let selector = $selectOpera.data("descending-selector");
    let container = $(selector).closest('.has_many_container.worker_worker_types')
    $.ajax({
        type: "POST",
        url: $selectOpera.data("descending-elements-url"),
        data: {
            opera_id: $selectOpera.val(),
        },
        success: function (results) {
            characters = results.characters;
        },
        dataType: 'json'
    });
}

function buildRes($selectOpera) {
    let selector = $selectOpera.data("descending-selector");
    let container = $(selector).closest('.has_many_container.worker_worker_types')
    let elementsToRemove = container.find("fieldset.inputs.has_many_fields");
    let elementsWithTemplate = container.find("a.button.has_many_add");
    $.ajax({
        type: "POST",
        url: $selectOpera.data("descending-elements-url"),
        data: {
            opera_id: $selectOpera.val(),
        },
        success: function (results) {
            let data = results.data;
            characters = results.characters;

            elementsToRemove.remove();

            $(data).each(function (i, current_data) {
                let index = i - 1;
                container.data({has_many_index: ++index})

                const regex = new RegExp(elementsWithTemplate.data('placeholder'), 'g');
                let html = elementsWithTemplate.data('html').replace(regex, index);
                const fieldset = $(html).insertBefore(elementsWithTemplate);
                if (current_data.worker_type_id) {
                    let $element = fieldset.find("select[id$=\"worker_type_id\"]");
                    $element.val(current_data.worker_type_id)
                    $element.trigger('change.select2')
                }

                initCharacters(fieldset)
                const $element = fieldset.find("select[id$=\"character_id\"]");

                if (current_data.character_id) {
                    $element.val(current_data.character_id)
                    $element.trigger('change.select2')
                }
                recompute_positions(container);

                $(fieldset).find("select").each(function() {
                   $(this).select2();
                });


            });
        },
        dataType: 'json'
    });
}
function initCharacters(fieldset) {
    const $element = $(fieldset).find("select[id$=\"character_id\"]");
    $element.empty();
    $element.append(`<option value=""> </option>`);
    $.each(characters, function (index, obj) {
        $element.append(`<option value="${obj.id}">${obj.name}</option>`);
    });
}

function initRecords() {
    let parents = $('select:data(descending-elements-url)');
    console.log("parents", parents)
    if (parents.length > 0) {
        parents.each(function (index, parent) {
            $(parent).on("change", function () {
                buildRes($(this))
            });
            let selector = $(parent).data("descending-selector");
            let container = $(selector).closest('.has_many_container.worker_worker_types')
            let elementsToRemove = container.find("fieldset.inputs.has_many_fields");
            if (elementsToRemove.length == 0) {
                $(parent).trigger('change');
            } else {
                loadChars($(parent));
            }
        });
    }
}

$(document).ready(function () {
    $(".flatpickr").each(function (index, element) {
        initFlatpickr($(element).parent());
    })

    initRecords();

    $(document).on('has_many_add:after', '.has_many_container', function (e, elem) {
        initFlatpickr($(elem));
        initCharacters($(elem));
    });

    $('.jsoneditor-target').each(function () {
        var container, editor, target;
        target = $(this);
        container = $('<div class="jsoneditor-container">').insertAfter(target);
        editor = new JSONEditor(container[0], {
            modes: ['tree'],
            // modes: ['code', 'form', 'text', 'tree', 'view'],
            templates: [
                [
                    {
                        "label": "",
                        "value": ""
                    }
                ]

            ],
            onChange: function () {
                return target.val(JSON.stringify(editor.get()));
            }
        });
        editor.set((function () {
            try {
                return JSON.parse(target.val() || "[ { \"label\": \"\", \"value\": \"\" } ]");
            } catch (_error) {
                console.log((_error))
            }
        })());
        return target.hide();
    });
})